module.exports = __webpack_public_path__ + "static/media/abouthero.22bccf06.png";